import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { PromoLabel } from '@/components/LabelsSection';
import {
  useEasterLabel,
  usePromotionsAvailability,
} from '@/modules/promotions';
import { useCommonStore } from '@/store/commonStore';

export const useLabels = (isDashboard?: boolean): PromoLabel[] => {
  const {
    user,
    diceRollMenuData,
    bonanzaPromoMenuData,
    scratchGameMenuData,
    fortuneWheelMenuData,
  } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
      diceRollMenuData: state.diceRollMenuData,
      bonanzaPromoMenuData: state.bonanzaPromoMenuData,
      scratchGameMenuData: state.scratchGameMenuData,
      fortuneWheelMenuData: state.fortuneWheelMenuData,
    }))
  );

  const easterLabel = useEasterLabel();

  const {
    isEasterAvailable,
    isScratchGameAvailable,
    isBonanzaPromoAvailable,
    isFortuneWheelAvailable,
    isDiceRollAvailable,
  } = usePromotionsAvailability();

  return useMemo(
    () => [
      {
        character: bonanzaPromoMenuData?.menu?.unloggedCharacter?.url,
        background: bonanzaPromoMenuData?.menu?.bg?.url,
        url: '/bonanza',
        available:
          !user && !!bonanzaPromoMenuData?.menu && isBonanzaPromoAvailable,
      },
      {
        character: scratchGameMenuData?.menu?.character?.url,
        background: scratchGameMenuData?.menu?.bg?.url,
        url: '/scratch-card',
        available: !!scratchGameMenuData?.menu && isScratchGameAvailable,
      },
      {
        character: fortuneWheelMenuData?.menu?.character?.url,
        background: fortuneWheelMenuData?.menu?.bg?.url,
        url: '/lucky-wheel',
        available:
          !isDashboard &&
          !!fortuneWheelMenuData?.menu &&
          isFortuneWheelAvailable,
      },
      {
        character: diceRollMenuData?.menu?.character?.url,
        background: diceRollMenuData?.menu?.bg?.url,
        url: '/dice-roll',
        available:
          !isDashboard && !!diceRollMenuData?.menu && isDiceRollAvailable,
      },
      {
        ...easterLabel,
        available: isEasterAvailable,
      },
    ],
    [
      user,
      isDashboard,
      bonanzaPromoMenuData,
      isEasterAvailable,
      easterLabel,
      isScratchGameAvailable,
      scratchGameMenuData,
      isBonanzaPromoAvailable,
      fortuneWheelMenuData,
      isFortuneWheelAvailable,
      isDiceRollAvailable,
      diceRollMenuData,
    ]
  );
};
